export default "__VITE_ASSET__2a87ebc3__"